import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DateIcon from "../../../imgs/date-icon.svg";
import { createLot } from "../../../network/fetch";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";
import State from "../State";

const Step1Form = (params) => {
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission
  const [tutorialStep, setTutorialStep] = useState(0);
  const [txUrl, setTxUrl] = useState("");
  const navigate = useNavigate();
  const dateInputRef = useRef(null);

  // Définir le nombre total d'étapes et l'étape actuelle
  const total_steps = 4; // Par exemple, s'il y a 5 étapes au total
  const current_step = 1; // Étape actuelle

  // State for form fields
  const [formData, setFormData] = useState({
    location: "",
    lotName: "",
    quantity: "",
    buyerInfo: State.defaultClient == null ? "" : State.defaultClient,
    date: new Date().toISOString().split("T")[0],
    convertedDate: "",
    toggle1: false,
    toggle2: false,
    toggle3: false,
    toggle4: false,
    toggle5: false,
  });

  let newLot = {
    lotId: "",
    quantity: 0,
    timestamp: "",
    location: "",
    buyer: State.defaultClient == null ? "" : State.defaultClient,
    subLotIds: "",
  };

  const supplyChainNextStep = (e) => {
    e.preventDefault();
    State.defaultClient = null;
    navigate("/supplychain/step2", {
      replace: true,
    });
    return;
  }
  

  // Gestion des popups tutoriels
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Encodez vos données (1/2)</p>
          <p>
            En tant qu'opérateur du couvoir, vous devez enregistrer un nouveau
            lot de poussins. Une fois les informations saisies, elles seront
            automatiquement envoyées et inscrites sur la blockchain, les rendant
            accessibles aux autres acteurs de la chaîne.
          </p>
        </>
      ),
      position: { top: "320px", left: "50%", transform: "translateX(-50%)" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Confidentialité (2/2)</p>{" "}
          <p>
            A titre démonstratif, vous pouvez choisir
            de cacher certaines informations aux autres
            acteurs afin d’en assurer la confidentialité.
          </p>
        </>
      ),
      showArrow: true,
      position: { top: "180px", left: "73%", width: "350px" },
      closeLabel: "hidden",
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);
  let submitedStep = [
    {
      content: (
        <>
          <p className="tutorial-title">
            Vos informations ont été enregistrées avec succès
          </p>
          <p>
            Vous avez enregistré les informations du lot de poussins. Ces
            données sont désormais accessibles via la blockchain pour les autres
            acteurs de la chaîne. Cliquez sur le bouton ci-dessous pour
            consulter les informations disponibles.
          </p>
          <p>
            {" "}
            <b>
              Vous pouvez soumettre d’autres lots ou passer à l’étape suivante.
            </b>
          </p>
        </>
      ),
      closeLabel: "Enregistrez un nouveau lot",
      nextLabel: "Etape suivante",
      handleNextTutorialStep: (e)=>{
        supplyChainNextStep(e);
      },
      position: {
        top: "320px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "950px",
      },
    },
  ];

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Set submitting state to true
    console.log("=== formData === Step1Form.js === key: 390634 ===");
    console.dir(formData, { depth: null, colors: true });
    console.log("=================================");
    State.defaultClient =
      State.defaultClient === null ? formData.buyerInfo : State.defaultClient;
    newLot = {
      ...newLot,
      lotId: formData.lotName,
      quantity: formData.quantity,
      timestamp: formData.convertedDate,
      location: formData.location,
      buyer: State.defaultClient,
    };
    // newLot ={ ...newLot, lotId: "XYZXYZzz", quantity: 100, timestamp: formData.convertedDate, location: formData.location, buyer: formData.buyerInfo };
    console.log("=== newLot === Step1Form.js === key: 587746 ===");
    console.dir(newLot, { depth: null, colors: true });
    console.log("=================================");

    // Validation to check if all fields are filled
    if (isFormValid()) {
      const resp = await createLot(newLot);

      console.log("=== resp === Step1Form.js === key: 371627 ===");
      console.dir(resp, { depth: null, colors: true });
      console.log("=================================");
      console.log("=== resp.data.tx_uri === Step1Form.js === key: 493521 ===");
      console.dir(resp.data.tx_uri, { depth: null, colors: true });
      console.log("=================================");
      if (resp.success === true) {
        State.lots.push(newLot.lotId);
        setTxUrl(resp.data.tx_uri);
        setTutorialSteps(submitedStep);
        setTutorialStep(0);
        setFormData({
          location: "",
          lotName: "",
          quantity: "",
          buyerInfo: State.defaultClient == null ? "" : State.defaultClient,
          date: new Date().toISOString().split("T")[0],
          convertedDate: "",
          toggle1: false,
          toggle2: false,
          toggle3: false,
          toggle4: false,
          toggle5: false,
        });
        newLot = {
          lotId: "",
          quantity: 0,
          timestamp: "",
          location: "",
          buyer: State.defaultClient == null ? "" : State.defaultClient,
          subLotIds: "",
        };
      }
      // navigate("/supplychain/step2", { replace: true });
    } else {
      alert("Please fill in all the required fields.");
    }
    setIsSubmitting(false); // Set submitting state back to false

    // Affichage du message de confirmation
   /*
    setShowConfirmation(true);

    // Après 2 secondes, démarrer le fade-out
    setTimeout(() => {
      setFadeOut(true);
    }, 2000);

    // Après 3 secondes, masquer le message de confirmation et réafficher le bouton
    setTimeout(() => {
      setShowConfirmation(false);
      setFadeOut(false); // Réinitialiser le fade-out pour les futures soumissions
    }, 3000);
   */
  };

  const isFormValid = () => {
    formData.convertedDate = new Date(formData.date).toISOString();
    if (isNaN(formData.quantity)) {
      formData.quantity = 1;
    }
   // formData.quantity = formData.quantity.replace(/\D/g, '')
    formData.quantity = parseInt(formData.quantity||0);
    formData.location = formData.location
      .replace(/\s+/g, " ")
      .replace(/,+/g, ",")
      .replace(/\.+/g, ".")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");
    formData.lotName = formData.lotName
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");
    formData.buyerInfo =
      State.defaultClient === null
        ? formData.buyerInfo.replace(/\s+/g, " ").replace(/[^\p{L}\p{N}\-., ]+/gu, "")
        : State.defaultClient;
    return (
      formData.location &&
      formData.lotName &&
      formData.quantity &&
      formData.buyerInfo &&
      formData.date
    );
  };

  return (
    <form onSubmit={handleSubmit} className="container">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>

      {/* Affichage du popup tutoriel */}
      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={tutorialSteps[tutorialStep].handleNextTutorialStep || handleNextTutorialStep}
          onClose={handleCloseTutorial}
          txUrl={txUrl}
          showArrow={tutorialSteps[tutorialStep].showArrow === true} 
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel} 
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}

      <div className="fiels-main-wrapper">
        <div className="fields-main">
          <div className="fields-main-switch-main">
            <div className="spacer"></div>
            <p className="form-switchs-label">Données confidentielles</p>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="date" className="form-label">
                Date d'envoi des poussins{" "}
              </label>
              <input
                type="date"
                className="form-control"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                placeholder="jj/mm/aaaa"
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                ref={dateInputRef}
              />
              <span
                className="date-icon"
                onClick={() =>
                  dateInputRef.current &&
                  dateInputRef.current.showPicker &&
                  dateInputRef.current.showPicker()
                }
              >
                <img src={DateIcon} alt="Date Icon"></img>
              </span>
            </div>
            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle1"
                name="toggle1"
                checked={formData.toggle1}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="location" className="form-label">
                Localisation du couvoir{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
                placeholder="ex: Crupet, Belgique"
                maxLength={45}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle2"
                name="toggle2"
                checked={formData.toggle2}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="lotName" className="form-label">
                Nom du lot de poussins{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="lotName"
                name="lotName"
                value={formData.lotName}
                onChange={handleChange}
                required
                placeholder="ex: Lot ABC123"
                maxLength={25}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle3"
                name="toggle3"
                checked={formData.toggle3}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="quantity" className="form-label">
                Quantité de poussins{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="quantity"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                required
                placeholder="ex: 1000"
                maxLength={9}
              />
            </div>
            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle4"
                name="toggle4"
                checked={formData.toggle4}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="buyerInfo" className="form-label">
                Information acheteur{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="buyerInfo"
                name="buyerInfo"
                value={formData.buyerInfo}
                onChange={handleChange}
                required
                placeholder="ex: Société XYZ"
                maxLength={45}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle5"
                name="toggle5"
                checked={formData.toggle5}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="btn-wrapper">
          {!isSubmitting && (
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isFormValid()}
            >
              Enregistrer le lot
            </button>
          )}
          {isSubmitting && (
            <div className="spinner-wrapper">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>

        <div className="next-btn-wrapper">
          <button
            className="btn btn-primary"
            disabled={State.lots.length === 0 || tutorialStep !== -1}
            onClick={supplyChainNextStep}
          >
            {" "}
            Passer à l'étape suivante: l'éleveur{" "}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Step1Form;
